/* jshint unused: false */
/* eslint no-unused-vars: 0 */

/**
 * Listener module
 * Initialize all model listeners by depending on them at runtime
 * No need to actually do something else
 */
angular.module('listeners')
    .run((
        UserListener, DevicesListener, EventsListener,
        LicenseListener, AppInstancesListener, ActionsListener,
        ActivationCodesListener,
    ) => { });



// WEBPACK FOOTER //
// ./scripts/common/listeners/listener.js